export default {
   methods: {
     fixedFormat(value, decimales = 2) {
       let val = (value / 1).toFixed(decimales).replace(",", ".");
       return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     },
     explicitMoneyFormat(value, decimales = 2) {
       if(value == null) return "";
       else {
         return "$" + this.fixedFormat(value, decimales);
       }
     },
     intDigitsFormat(value){
       if(value == null) {
         return 0
       }
       else {
         return value.toFixed(0);
       }
     },
     mxnFormat(value){
       if(!value){ return "$0";}
       else {
         return "$" + this.fixedFormat( parseInt(value), 0) + "MXN";
       }
     },
     moneyFormat(value){
       if(!value){ return "$0";}
       else {
         return "$" + this.fixedFormat( parseInt(value), 0);
       }
     },
     decimalPercentFormat(value, decimales = 2){
       if(!value) return "0%";
       else {
         return (value * 100).toFixed(decimales) + "%";
       }
     },
     roundedFormat(value, decimales = 2){
       if(!value){ return 0; }
       else {
         let c = value.toFixed(decimales);
         let cd = Math.round(c);
         return cd.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
       }
     },
     stringToFloat(strValue){
       return parseFloat(strValue.toString());
     },
     phoneFormat(value){
       if(!value) return value
       else {
         return '(' + value.substr(0, 2) + ') ' + value.substr(2, 4) + '-' + value.substr(6,4)
       }
     }
   }
 }